import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useLayoutEffect } from 'react';
import cx from '../../utils/classNames';
import styles from './SkeletonDisplayText.module.css';
const styleHelper = (attribute, value) => {
    return `${attribute}--${value}`;
};
const defaultHeight = 'medium';
const defaultLength = 'medium';
const SkeletonDisplayText = ({ className, height = defaultHeight, possibleLengths = [defaultLength], opacityIndex = 0, }) => {
    const [lengthKey, setLengthKey] = useState(defaultLength);
    // prevent random size from changing
    const [renderGuard, setRenderGuard] = useState(false);
    useLayoutEffect(() => {
        if (!renderGuard) {
            setLengthKey(possibleLengths[Math.floor(Math.random() * possibleLengths.length)]);
            setRenderGuard(true);
        }
    }, [renderGuard, possibleLengths]);
    const lengthStyle = styles[styleHelper('length', lengthKey)];
    return (_jsx("div", { className: cx(className, styles[`displayText${opacityIndex}`], styles.displayText, styles[styleHelper('height', height)], lengthStyle) }, void 0));
};
export default SkeletonDisplayText;
